import React from 'react';

function Td ({ title, value, children }) {
  return (
    <td
      style={{
        fontSize: '12px',
        verticalAlign: 'center',
        padding: '4px 12px',
        width: '220px',
        border: 0
      }}
    >
      {children ? children : <TdItem title={title} value={value} />}
    </td>
  );
}

function TdItem ({ title, value }) {
  return (
    <div>
      <strong>{title}</strong>
      <span style={{ marginLeft: '5px' }}>{value}</span>
    </div>
  );
}
export { Td, TdItem };



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Imuno/Impressao/Table/Td/index.js